import Vue from 'vue'
import noResult from '@/components/noResult'
import ClientHeader from '@/pages/clients/components/Header'
import ClientSearch from '@/pages/clients/components/Search'
import ClientResult from '@/pages/clients/components/Result'
import AdvancedSearch from '@/pages/company/components/AdvancedSearch'
import CompanyOption from '@/components/Option'
import CompanyTable from '@/pages/company/components/Table'
import ThirdScreen from '@/pages/company/components/tables/Screen3'
import FourthScreen from '@/pages/company/components/tables/Screen4'

import Rating from '@/components/Rating'

Vue.component('no-result', noResult)
Vue.component('client-search', ClientSearch)
Vue.component('client-header', ClientHeader)
Vue.component('client-result', ClientResult)
Vue.component('advanced-search', AdvancedSearch)
Vue.component('company-option', CompanyOption)
Vue.component('company-table', CompanyTable)
Vue.component('third-screen', ThirdScreen)
Vue.component('fourth-screen', FourthScreen)

Vue.component('rating', Rating)

export default {}



// WEBPACK FOOTER //
// ./src/components/index.js